import { useMemo, useState } from 'react';

import { useProducts, Product } from './useProducts';

type ProductOption = {
  id: string;
  name: string;
  childMenu: {
    options: { value: string; label: string }[];
    onChange: (value: string) => void;
  };
};

export const useProductOptions = (): {
  productOptions: ProductOption[];
  loading: boolean;
  productToEdit: Product | null;
  productToDelete: Product | null;
  clearSelectedProductState: () => void;
} => {
  const { loading, products } = useProducts();
  const [productToEdit, setProductToEdit] = useState<Product | null>(null);
  const [productToDelete, setProductToDelete] = useState<Product | null>(null);

  const clearSelectedProductState = (): void => {
    setProductToEdit(null);
    setProductToDelete(null);
  };

  const productOptions = useMemo(
    () =>
      products?.map((product) => ({
        id: product.id,
        name: product.name,
        childMenu: {
          options: [
            { value: 'edit', label: 'Edit' },
            { value: 'remove', label: 'Remove' },
          ],
          onChange: (value: string): void => {
            if (value === 'remove') {
              setProductToDelete(product);
            } else {
              setProductToEdit(product);
            }
          },
        },
      })),
    [products],
  );

  return {
    productOptions,
    loading,
    productToEdit,
    productToDelete,
    clearSelectedProductState: clearSelectedProductState,
  };
};
